export const GET_FEATURE_FLAGS_SUCCESS = 'GET_FEATURE_FLAGS_SUCCESS'
export const UPDATE_USER_FEATURE_FLAGS = 'UPDATE_USER_FEATURE_FLAGS'
